<template>
  <PageContainer>
    <el-row class="sex-section">
      <el-col :xs="24" :sm="24" :md="{offset: 2, span: 10}">
        <img :src="ProhibitImage">
      </el-col>
      <el-col :xs="24" :sm="24" :md="10">
        <MarkComponent v-for="({title, content}, index) in contents" :key="index">
          <template>
            <p class="title">{{ title }}</p>
            <p class="content" v-html="content" />
          </template>
        </MarkComponent>
      </el-col>
    </el-row>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
import ProhibitImage from '@/assets/img/img_prohibit.png'
import MarkComponent from '@/components/MarkComponent.vue'
export default {
  components: {
    PageContainer,
    MarkComponent
  },
  data() {
    return {
      ProhibitImage,
      contents: [
        {
          title: '性騷擾防治專區',
          // eslint-disable-next-line vue/no-parsing-error
          content: '本公司為防治及處理性騷擾事件，提供免受性騷擾之工作及服務環境，特依性別工作平等法第 13 條、工作場所性騷擾防治措施申訴及懲戒辦法訂定準則及性騷擾防治法第 7 條規定，訂定「希望聯盟消費合作社性騷擾防治措施、申訴及懲戒處理要點」，並設有工作場所性騷擾申訴管道，相關資訊如下：<br/>申訴專線電話： 04-24068880<br/>申訴電子信箱： hisehjenny@zjdzec.com'
        },
        {
          title: '本公司防治性騷擾事件書面聲明',
          content: '希望聯盟消費合作社禁止工作場所性騷擾之書面聲明'
        },
        {
          title: '本公司防治性騷擾事件相關作業規定',
          content: '希望聯盟消費合作社性騷擾防治措施、申訴及懲戒處理要點'
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
.sex-section {
  width: 100%;
  img {
    width: 100%;
    margin-bottom: 20px;
    @include minWidth992 {
      width: 75%;
      margin-bottom: 0px;
    }
  }
}
::v-deep.mark {
  top: 10px;
}

.title {
  font-size: 24px;
  color: $mainPurple;
}
.content {
  color: $deepGrey;
  font-size: 14px;
}
</style>

